import {Middleware, isFulfilled, isRejected} from "@reduxjs/toolkit";
import {API_SUCCESS} from "../types";
import {setAuthStatus} from "../features/auth/sessionAuthSlice";

const AUTH_REDIRECT_TS_KEY = "auth_redirect_ts";
const AUTH_REDIRECT_LOOP_WINDOW_MS = 10_000;

const isInRedirectLoop = (): boolean => {
    const raw = sessionStorage.getItem(AUTH_REDIRECT_TS_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (Number.isNaN(ts)) return false;
    return Date.now() - ts < AUTH_REDIRECT_LOOP_WINDOW_MS;
};

const is401 = (action: unknown): boolean => {
    if (!isRejected(action)) return false;
    const payload = (action as {payload?: unknown}).payload;
    return (
        !!payload &&
        typeof payload === "object" &&
        "status" in payload &&
        (payload as {status: unknown}).status === 401
    );
};

export const sessionGuardMiddleware: Middleware =
    (api) => (next) => (action) => {
        if (isFulfilled(action)) {
            if (typeof document !== "undefined") {
                document.dispatchEvent(
                    new CustomEvent(API_SUCCESS, {detail: {success: true}})
                );
            }
        } else if (
            is401(action) &&
            typeof window !== "undefined" /*  &&
            !window.location.hostname.includes("localhost") */
        ) {
            api.dispatch(
                setAuthStatus(isInRedirectLoop() ? "loopBlocked" : "expired")
            );
        }

        return next(action);
    };
